<template>
  <ItemUnavailableSummary />

  <ProsZoneUnavailable zone="PDP_ZONE_I" />
  <ProsZoneUnavailable zone="PDP_ZONE_J" />
  <ProsZoneUnavailable zone="PDP_ZONE_K" />

  <SiteMonetization placement="inline" />

  <RecentlyViewedItems />

  <div class="cell x-small-12 small-margin-bottom-l medium-margin-bottom-xxl">
    <div class="divider"></div>
  </div>

  <div id="product-card-details" ref="productCard" class="grid-x grid-margin-x small-margin-bottom-xl large-margin-bottom-xxl">
    <div v-if="isMobile && isMcom" class="cell h4 margin-bottom-xs">Still curious? Here’s a closer look</div>
    <div v-if="isMobile" class="cell title-mobile medium-padding-bottom-xs">
      <UnavailableProductTitle is-details />
    </div>
    <ReviewRating v-if="isMobile" />

    <div :class="cellLeft">
      <Media class="small-margin-top-xs medium-margin-top-z" />
    </div>
    <div :class="cellRight">
      <div v-if="!isMobile && isMcom" class="h4 margin-bottom-s">Still curious? Here’s a closer look</div>
      <div v-if="!isMobile" class="title">
        <UnavailableProductTitle is-details />
      </div>

      <ReviewRating v-if="!isMobile" />

      <BusyButton ref="button" variant="emphasis" expanded :disabled="true" aria-label="unavailable" class="margin-top-s margin-bottom-m">
        <slot>
          <span :class="{ uppercase: isBcom }"> Unavailable </span>
        </slot>
      </BusyButton>
    </div>
    <div class="cell large-12" data-testid="product-details-section">
      <ProductDetails :class="{ 'margin-top-xl': !isMobile && !showSponsoredItemTop }" />

      <SiteMonetization placement="bottom" />

      <ReviewSection v-if="showReviewSection" class="margin-top-xxl" />
    </div>
  </div>
</template>

<script setup lang="ts">
import ProsZoneUnavailable from '~/modules/pros/ProsZoneUnavailable.vue';
import RecentlyViewedItems from '~/modules/pros/RecentlyViewedItems.vue';
import StaticImportProductDetails from '~/modules/productDetails/components/ProductDetails.vue';
import LazyHydratedProductDetails from '~/modules/lazy-hydration/components/ProductDetails.vue';
import SiteMonetization from '~/components/monetization/SiteMonetization.vue';
import UnavailableProductTitle from '~/components/productTitle/UnavailableProductTitle.vue';
import StaticImportReviewSection from '~/modules/reviews/components/ReviewSection.vue';
import LazyHydratedReviewSection from '~/modules/lazy-hydration/components/ReviewSection.vue';
import ReviewRating from '~/modules/reviews/components/ReviewRating.vue';
import Media from '~/components/common/Media/Media.vue';
import BusyButton from '~/modules/ui/components/BusyButton.vue';
import ItemUnavailableSummary from './ItemUnavailableSummary.vue';

import useFeatureEligibility from '~/modules/featureControl/composables/useFeatureEligibility';
import useGridLayoutConfig from '~/composables/useGridLayoutConfig';
import useKillswitches from '~/modules/featureControl/composables/useKillswitches';
import { usePostPurchaseAnchor } from '~/composables/usePostPurchaseAnchor';
import { useSiteMonetizationProvide } from '~/composables/monetization/useSiteMonetization';
import { useDeviceType } from '~/composables/utils/useDeviceType';
import { useBrand } from '~/composables/useBrand';

const productCardRef = useTemplateRef('productCard');

useSiteMonetizationProvide();

const { isMobile } = useDeviceType();
const { killswitches } = useKillswitches();
let ReviewSection = StaticImportReviewSection,
  ProductDetails = StaticImportProductDetails;

// TODO: remove later once lazy hydration testing is over
if (killswitches.isLazyHydrationEnabled) {
  ReviewSection = LazyHydratedReviewSection;
  ProductDetails = LazyHydratedProductDetails;
}

const { isBcom, isMcom } = useBrand();
const { showSponsoredItemTop, showReviewSection } = useFeatureEligibility();

const { cellLeft, cellRight } = useGridLayoutConfig();

usePostPurchaseAnchor(productCardRef);
</script>




<style lang="scss" scoped>
@import '~settingSCSS';
@include title;

.divider {
  position: relative;
}
.divider:before {
  background-color: $background-color;
  content: '';
  height: 8px;
  left: -20px;
  position: absolute;
  top: 0;
  width: 100vw;

  @media screen and (min-width: rem-calc(1440)) {
    width: 100%;
    left: 0;
  }
}


.uppercase {
  text-transform: uppercase;
}
</style>